import React from 'react';
import clsx from 'clsx';
import MuiTooltip from '@material-ui/core/Tooltip';
import { TOOLTIP } from 'ctsutheme/core';

const Tooltip = ({
  className, dark, children, ...props
}) => (
  <MuiTooltip
    component="div"
    className={clsx(TOOLTIP.root, className, dark && TOOLTIP.dark)}
    {...props}
  >
    <div>{children}</div>
  </MuiTooltip>
);
export default Tooltip;
